export const SET_USER_INFO = 'SET_USER_INFO'
export const SET_TABS_INDEX = 'SET_TABS_INDEX'
export const SET_EQUIPMENTID = 'SET_EQUIPMENTID'
export const SET_HOMEDESKTOP = 'SET_HOMEDESKTOP'
export const SET_WAREHOUSELIST = 'SET_WAREHOUSELIST'
export const SET_IMGSHOW = 'SET_IMGSHOW'
export const SET_CLIENTINFO='SET_CLIENTINFO'
export const SET_SUP_COLLAB_SHARE_VERIFY_CODE='SET_SUP_COLLAB_SHARE_VERIFY_CODE'


// WEBPACK FOOTER //
// ./src/vuex/mutation-type.js